import "./HowToStartSection.scss";
import Button from "components/Button/Button";
import StratingSteps from "components/StratingSteps/StratingSteps";
import {
  getIndividualClientText,
  getBusinessesClientText,
} from "../../constants/startingStepsText";
import individualClient from "../../assets/images/individualClient.svg";
import businessesClinet from "../../assets/images/businessesClinet.svg";
import { scrollToSection } from "utils/scroll";
import { useTranslation, Trans } from "react-i18next";

const HowToStartSection = () => {
  const { t } = useTranslation();

  return (
    <div className="how-to-start-container" id="how-to-start">
      <h2 className="main-title">{t("titles.howToStart")}</h2>
      <div className="sub-title title-border">
        {t("subtitles.howToStartSubtitle1")}
      </div>
      <div className="sub-title">
        <Trans
          i18nKey={"subtitles.howToStartSubtitle2"}
          components={{ span: <span /> }}
        />
      </div>
      <div className="starting-steps">
        <StratingSteps
          stepsArr={getIndividualClientText().steps}
          icon={individualClient}
          title={getIndividualClientText().title}
        />
        <StratingSteps
          stepsArr={getBusinessesClientText().steps}
          icon={businessesClinet}
          title={getBusinessesClientText().title}
        />
      </div>
      <Button
        className={"blue-btn"}
        btnName={t("buttons.startYourPath")}
        onClick={() => {
          scrollToSection("home");
        }}
      />
    </div>
  );
};

export default HowToStartSection;
